import * as React from 'react';
import Component from '../../../Component';
import Display from './Display';
import Form from './Form';
import Header from '../Header/Header';

export default class Settings extends Component {
    constructor(props?: any) {
        super(props);
        this.state = {
            subsidiary: this.props.subsidiary,
            editMode: false
        };
    }

    render() {
        return (
            <div className="w-100">
                <Header
                    subsidiary={this.state.editMode ? this.state.subsidiary : this.props.subsidiary}
                    currentTab={this.props.currentTab}
                    onTabChange={(tab: any) => {
                        if (this.props.onTabChange) { this.props.onTabChange(tab); }
                    }}
                />
                <div className="col-12 mb-3">
                    {(this.state.editMode) ?
                        <Form
                            subsidiary={this.props.subsidiary}
                            onUpdate={(subsidiary: any) => { this.setState({ subsidiary }); }}
                            onCancel={() => { this.setState({ editMode: !this.state.editMode }); }}
                            onRefresh={() => { if (this.props.onRefresh) { this.props.onRefresh(); } }}
                        />
                        : <Display
                            subsidiary={this.props.subsidiary}
                            onEdit={() => { this.setState({ editMode: !this.state.editMode }); }}
                            onRefresh={() => { if (this.props.onRefresh) { this.props.onRefresh(); } }}
                        />}
                </div>
            </div>
        );
    }
}